import {Booking} from '../../api/types';
import BookingDepot from './BookingDepot';
import {Grid} from '@mui/material';

interface BookingDepotsProps {
    booking: Booking;
}

const BookingDepots = (props: BookingDepotsProps) => {
    const hasBeenFinished = Boolean(
        props.booking?.items[0]?.rental && !props.booking?.items[0]?.rental?.isActive,
    ); 

    return (<>
        {props.booking.items.map(item => {
            return (
                <Grid key={item.id} item={true} xs={12} md={9}>
                    {(item.depot?.id && !hasBeenFinished)
                        ? (
                            <BookingDepot
                                depot={item.depot}
                                depotId={item.depot.id}
                                depotName={item.depot.name}
                                doors={item.doors?.map((obj) => obj.door) as number[]}
                                booking={props.booking}
                            />
                        )
                        : (
                            null
                            // <Alert severity={'error'}>
                            //     Could not determine the depot number or door numbers of depot {item.depot?.id}.
                            // </Alert>
                        )}
                </Grid>
            );
        })}
    </>);
};

export default BookingDepots;
